import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import classnames from 'classnames'
import { Button, Form, FormField, Text, If, Unless } from 'src/Components'
import PhoneInput from 'src/Components/shared/Input/PhoneInput'
import { IconPencil } from 'src/Components/shared/Icon'
import { selectClientMobile } from 'src/store/selectors/client'

import styles from './PhoneNumberPrompt.module.scss'

const PhoneNumberPrompt = ({ handleSave, copySubject }) => {
  const clientPhone = useSelector(selectClientMobile)

  const [inputEditable, setInputEditable] = useState(!clientPhone)
  const [mobile, setMobile] = useState(clientPhone)
  const [dirty, setDirty] = useState(false)

  const phone = FormField.Phone.defaultProps.name
  const phoneField = {
    name: phone,
    conditions: [PhoneInput.validNumber()]
  }

  const onSubmit = (e, data) => {
    e.preventDefault()
    handleSave(data.phone, inputEditable && dirty)
  }

  const toggleEdit = e => {
    e.preventDefault()
    setInputEditable(true)
  }

  const handleChange = (_e, value) => {
    setMobile(value)
    setDirty(true)
  }

  const MobileDescription = props => (
    <Text size='xs' color='quiet' align='left' {...props}>
      <FormattedMessage
        id='Homeowner.teasers.notification.platform.mobilelLabel'
        defaultMessage='Mobile number'
      />
    </Text>
  )

  return (
    <div className={styles.container}>
      <div className={styles.copyWrapper}>
        <Text align='center' size='l'>
          <If condition={inputEditable}>
            <FormattedMessage
              id='Homeowner.teasers.notification.platform.editing'
              defaultMessage="{copySubject} will be live soon! Add your mobile number to be alerted when it's ready:"
              values={{ copySubject }}
            />
          </If>
          <Unless condition={inputEditable}>
            <FormattedMessage
              id='Homeowner.teasers.notification.platform.notEditing'
              defaultMessage='Confirm that this looks right:'
            />
          </Unless>
        </Text>
      </div>

      <div className={styles.formWrapper}>
        <Form fields={[phoneField]} onSubmit={onSubmit}>
          <div className={styles.inputContainer}>
            <FormField.Phone
              disabled={!inputEditable}
              readOnly={!inputEditable}
              className={classnames(
                styles.inputWrapper,
                !inputEditable && styles.hideLabel
              )}
              inputClassName={classnames(styles.input, {
                [styles.input__readOnly]: !inputEditable
              })}
              labelText={MobileDescription}
              conditions={phoneField.conditions}
              value={mobile}
              placeholder='555-555-5555'
              onChange={handleChange}
            />
            <Unless condition={inputEditable}>
              <Button className={styles.editButton} onClick={toggleEdit}>
                <IconPencil />
              </Button>
            </Unless>
          </div>

          <Button fullWidth primary type='submit'>
            <If condition={inputEditable}>
              <FormattedMessage
                id='General.buttons.save'
                defaultMessage='Save'
              />
            </If>
            <Unless condition={inputEditable}>
              <FormattedMessage
                id='General.buttons.confirm'
                defaultMessage='Confirm'
              />
            </Unless>
          </Button>
        </Form>
      </div>
    </div>
  )
}

PhoneNumberPrompt.propTypes = {
  handleSave: PropTypes.func.isRequired,
  copySubject: PropTypes.string
}

export default PhoneNumberPrompt
